var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-menu-mask",class:{'is-collapsed': _vm.isCollapsed}})
}
var staticRenderFns = []

export { render, staticRenderFns }